import React from "react";
import { Check } from "lucide-react";
import { systemOptions } from "../../../constants";

const SourceSystemSelector = ({ sourceSystem, setSourceSystem }) => {
  const handleSystemSelect = (systemId) => {
    setSourceSystem(systemId);
  };

  return (
    <div className="mt-6 space-y-6">
      <h3 className="text-lg font-medium text-gray-900">
        Choose your current system
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {systemOptions.map((system) => (
          <div
            key={system.id}
            className={`p-4 border rounded-lg cursor-pointer transition-all ${
              sourceSystem === system.id
                ? "border-blue-500 bg-blue-50 shadow-sm"
                : "border-gray-200 hover:border-blue-300 hover:bg-blue-50"
            }`}
            onClick={() => handleSystemSelect(system.id)}
          >
            <div className="flex items-center">
              {system.icon}
              <span className="text-gray-700">{system.name}</span>
              {sourceSystem === system.id && (
                <Check className="ml-auto text-blue-500" size={18} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SourceSystemSelector;
